import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import { Produto, CartItem } from '../tamas-models';
import { AlertaConfirmDialog } from '../alerta-confirm';
import { AlertaPremiumDialog } from '../alerta-premium';
import { AlertaSimplesDialog } from '../alerta-simples';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { jsonpCallbackContext } from '../../../node_modules/@angular/common/http/src/module';
import { FieldsCartao } from '../tamas-models';

declare var PagSeguroDirectPayment: any;

@Component({
  selector: 'app-shop-checkout',
  templateUrl: './shop-checkout.component.html',
  styleUrls: ['./shop-checkout.component.css']
})
export class ShopCheckoutComponent implements OnInit {
  @ViewChild("numeroInput") meuInputNumero: ElementRef;
  arrMeusEnderecos: any[] = []
  hideCL: boolean = false;
  // meuCarrinho: CartItem[];
  usuarioPremium: boolean = false;
  nomecc: any = '';
  numerocc: any = '';
  validade: any = '';
  cvv: any = '';
  pagarVT: any = 0;
  userSenderHash: any = '';
  carregouSH: boolean = false;
  logradouro: any = '';
  numero: any = '';
  bairro: any = '';
  cidade: any = '';
  uf: any = '';
  cep: any = '';
  complemento: any = '';
  numerocpf: any = '';
  numerocel: any = '';
  nascimento: any = '';
  meucpf: any = '';
  dadosCC: FieldsCartao = new FieldsCartao();
  checkoutDone: boolean = false;
  arrParcelas: any[] = [];
  qParcelas: any = 1;
  loadParcelas: boolean = false;
  enderecomsm: boolean = false;
  pgDone: boolean = false;
  nomeAtual: any = '';
  iTipoF: any = '';
  public maskCEP = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
  public maskCartao = [/[0-9]/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/,];
  public maskValidade = [/[0-9]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public maskCPF = [/[0-9]/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "-", /\d/, /\d/];
  public maskCelular = ["(", /[0-9]/, /\d/, ")", /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/, /\d/];
  public maskNascimento = [/[0-9]/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/];

  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService, public dialog: MatDialog, private cdRef: ChangeDetectorRef, private ngZone: NgZone) { }

  ngOnInit() {
    if (this.tmaService.shopCheck) {
      this.hideCL = true;
      this.iTipoF = this.tmaService.shopTipoFrete;
      //console.log(this.tmaService.shopCartFull);
      this.pagarVT = this.tmaService.shopValorTotal;
      console.log(this.pagarVT);
      this.arrParcelas.push({ quantity: 1, installmentAmount: this.pagarVT });
      //obter token da sessão
      this.getCodSession();
      this.nomeAtual = this.tmaService.hcNome;
    }
    else {
      this.router.navigate(['/pre-shop/uf']);
    }

  }

  getCodSession(): void {

    this.tmaService.criarSPS().subscribe((qRes) => {
      if (qRes['res'] == 'done') {
        console.log(qRes);
        var idSessaoP = qRes["codSession"];
        PagSeguroDirectPayment.setSessionId(idSessaoP);
      }

    });
  }


  obterSH(): void {
    var qHash = "";
    var nCarregou = 0;
    var $this = this;
    PagSeguroDirectPayment.onSenderHashReady(function (response) {
      if (response.status == 'error') {
        console.log(response.message);
        //nCarregou = 1;
        $this.carregouSH = false;
        return false;
      }
      else {
        console.log(response);
        //nCarregou = 0;
        //qHash = response.senderHash;
        $this.userSenderHash = response.senderHash;
        $this.carregouSH = true;
      }

    });
    // if (nCarregou == 1) {
    //   //erro
    //   this.carregouSH = false;
    // }
  }

  triggerSH(): void {
    console.log("trigger");
    if (!this.carregouSH) {
      this.obterSH();
      this.carregouSH = true;
      console.log("call sh");
    }
  }


  triggerPC(): void {
    if (!this.loadParcelas) {
      if (this.numerocc.length > 6) {
        console.log("call vp");
        this.verParcelas();
      }
    }
  }


  dgCartao(): void {
    if (this.loadParcelas) {
      //já carregou parcelamento, caso o cardbin mude, devemos calcular de novo, so
      if (this.numerocc.length <= 4) {
        this.loadParcelas = false;
        this.qParcelas = 1;
        this.arrParcelas = [];
        this.arrParcelas.push({ quantity: 1, installmentAmount: this.pagarVT });
      }
    }
    else {
      if (this.numerocc.length > 6) {
        console.log("call vp");
        this.verParcelas();
      }
    }
  }
  verParcelas(): void {

    if (this.numerocc.length < 4) {
      //digite o numero do cartão
      const alertTipo = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { tituloAlerta: 'Cartão', textoAlerta: 'Por favor digite o número do cartão para consultar as opções de parcelamento', iconAlerta: 'warning' }
      })
    }
    else {
      this.loadParcelas = true;
      var $this = this;
      var minhaBandeira = "";
      var cardBinFormated = this.numerocc.replace(/\./g, '').toString().substring(0, 6);
      console.log("cad bin " + cardBinFormated);
      PagSeguroDirectPayment.getBrand({
        cardBin: cardBinFormated,
        success: function (response) {
          //bandeira encontrada
          minhaBandeira = response.brand.name;
          console.log("bandeira do cartao");
          console.log(minhaBandeira);
          $this.consultarValorParcelas(minhaBandeira);
        },
        error: function (response) {
          //tratamento do erro
          console.log(response);
          $this.hideCL = true;
        },
        complete: function (response) {
          //tratamento comum para todas chamadas
          console.log(response);
        }
      });
    }

  }

  consultarValorParcelas(bandeira: any): void {
    var valorF = this.pagarVT;

    var $this = this;
    PagSeguroDirectPayment.getInstallments({
      amount: valorF,
      brand: bandeira,
      success: function (response) {
        // Retorna as opções de parcelamento disponíveis
        console.log(response);
        $this.arrParcelas = response.installments[bandeira];
        $this.cdRef.detectChanges();
        // console.log(response.installments);
        // console.log(response.installments[bandeira]);
        // console.log(response.installments['mastercard']);


      },
      error: function (response) {
        // callback para chamadas que falharam.
        console.log(response);
      },
      complete: function (response) {
        // Callback para todas chamadas.
        console.log(response);
      }
    });

  }


  pickParcelas(qEvent: any): void {
    console.log(qEvent);
    this.qParcelas = qEvent.value;
    this.cdRef.detectChanges();
    // console.log(this.arrParcelas.find(x => x.quantity == this.qParcelas).installmentAmount);
    // console.log(this.pagarVT);
    // console.log(this.pagarVT.toString().replace('.', ','));
  }



  changeCKend(): void {
    console.log("check change");
    if (!this.enderecomsm) {
      //agora true
      console.log("go true");
      //this.enderecomsm = true;
      console.log(this.tmaService.shopEnderecoEntrega);
      console.log(this.tmaService.shopEnderecoEntrega[0].CEP);
      //console.log(this.tmaService.shopEnderecoEntrega)
      this.cep = this.tmaService.shopEnderecoEntrega[0].CEP;
      this.logradouro = this.tmaService.shopEnderecoEntrega[0].Logradouro;
      this.complemento = this.tmaService.shopEnderecoEntrega[0].Complemento;
      this.numero = this.tmaService.shopEnderecoEntrega[0].Numero;
      this.bairro = this.tmaService.shopEnderecoEntrega[0].Bairro;
      this.cidade = this.tmaService.shopEnderecoEntrega[0].Cidade;
      this.uf = this.tmaService.shopEnderecoEntrega[0].UF
    }
  }
  voltar(): void {
    // this.router.navigate(['/shopping/endereco']);
    if(this.tmaService.paginaAnterior == 'shopping/endereco'){
      this.router.navigate([this.tmaService.paginaAnterior]);
    }
    else{
      this.router.navigate(['shopping/carrinho']);
    }
    //this._location.back();
  }

  goHome(): void {
    this.router.navigate(['/home']);
  }

  goShopping(): void {
    this.router.navigate(['/shop/' + this.tmaService.shopUF + '/' + this.tmaService.shopCidade]);
  }

  realizarPedido() {

    //exibir um modal de confirmacao com o valor do pedido , o nº de parcelas escolhido e o respectivo valor das mesmas, caso n seja a vista

    if (this.nomecc == '') {
      const alertTipo = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { tituloAlerta: 'Campo Obrigatório', textoAlerta: 'Por favor insira o <b>Nome do Titular</b>', iconAlerta: 'warning' }
      })
      return;
    }


    if (this.numerocc == '') {
      const alertTipo = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { tituloAlerta: 'Campo Obrigatório', textoAlerta: 'Por favor insira o <b>Número do Cartão</b>', iconAlerta: 'warning' }
      })
      return;
    }

    if (this.validade == '') {
      const alertTipo = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { textoAlerta: 'Para continuar você deve inserir a <b>Validade do Cartão</b>', iconAlerta: 'warning' }
      })
      return;
    }
    else {
      console.log(this.validade.length);
      if (this.validade.length != 7) {
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: 'A data de validade deve ser composta pelo mês/ano, exemplo: <b>01/2022</b>', iconAlerta: 'warning' }
        })
        return;
      }
    }

    if (this.cvv == '') {
      const alertTipo = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { textoAlerta: 'Por favor insira o <b>Código de Segurança</b> do cartão', iconAlerta: 'warning' }
      })
      return;
    }


    var arrMCart = "";
    var objMEndereco = "";
    var objCC = "";
    this.dadosCC.CardHolderName = this.nomecc;
    //this.dadosCC.CardNumber = this.numerocc.replace(".", "");
    this.dadosCC.CardNumber = this.numerocc.replace(/\./g, '');
    this.dadosCC.EndDate = this.validade;
    this.dadosCC.CCV = this.cvv;
    objCC = JSON.stringify(this.dadosCC);

    arrMCart = JSON.stringify(this.tmaService.shopCartFull);
    objMEndereco = JSON.stringify(this.tmaService.shopEnderecoEntrega);

    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      dadosCarrinho: arrMCart,
      dadosEndereco: objMEndereco,
      cupomdesconto: '',
      tipofrete: this.tmaService.shopTipoFrete,
      tipopagamento: 'online',
      cidade: this.tmaService.shopCidade,
      uf: this.tmaService.shopUF,
      dadosCartao: objCC
    };
    this.hideCL = false;
    //var dadosU = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idpaciente=' + this.idPaciente;
    this.tmaService.addNovoPedido(customParams).subscribe((qRes) => {
      this.hideCL = true;
      console.log(qRes);
      if (qRes['res'] == 'done') {
        //limpar carrinho etc
        //apos integrar com rede usar if abaixo
        this.tmaService.shopCheck = false;
        this.checkoutDone = true;
        this.tmaService.shopCartFull = [];
        localStorage.removeItem('tmsCarrinho');
        this.excluirIC();
        // if(qRes['pagamento'] == true){
        //   this.tmaService.shopCheck = false;
        //   this.tmaService.shopCartFull = [];
        //   this.tmaService.shopCheck = false;
        //   this.checkoutDone = true;
        // }
        // else{
        //   const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        //     disableClose: true,
        //     data: { textoAlerta: "Não foi possível processar seu pagamento. Tente novamente", iconAlerta: 'warning' }
        //   })
        // }

      }
      else {
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Ocorreu um erro ao realizar o pedido. Tente novamente", iconAlerta: 'warning' }
        })
      }
    },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
        });
      })
  }


  digitouCEP(info: string): void {
    console.log(info);
    console.log(info.replace(new RegExp("\\-", 'g'), "").length);
    //consultar cep
    if (info.replace(new RegExp("\\-", 'g'), "").replace(new RegExp("\\_", 'g'), "").length == 8) {
      this.hideCL = false;
      console.log("buscando cep");
      var dadosIn = info.replace(new RegExp("\\-", 'g'), "").replace(new RegExp("\\_", 'g'), "") + '/json/';
      this.tmaService.buscarCEPVia(dadosIn)
        .subscribe((qRes) => {
          console.log(qRes);
          if (qRes['erro'] == true) {
            this.hideCL = true;
          }
          else {
            this.hideCL = true;
            this.logradouro = qRes['logradouro'];
            this.bairro = qRes['bairro'];
            this.cidade = qRes['localidade'];
            this.uf = qRes['uf'];
            this.meuInputNumero.nativeElement.focus();
          }
        })
    }

    if (info.replace(new RegExp("\\-", 'g'), "").replace(new RegExp("\\_", 'g'), "").length == 0) {
      this.logradouro = '';
      this.bairro = '';
      this.cidade = '';
      this.uf = '';
    }


  }

  //pagseguro
  finalizarPgto(): void {
    //ps
    console.log(this.numerocpf.length);
    console.log(this.numerocpf.replace(/\./g, '').replace(/\-/g, '').length);
    console.log(window.navigator.userAgent);


    if (this.pagarVT > 0) {
      if (this.nomecc == '') {
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: 'Campo Obrigatório', textoAlerta: 'Por favor insira o <b>Nome do Titular</b>', iconAlerta: 'warning' }
        })
        return;
      }


      if (this.numerocc == '') {
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: 'Campo Obrigatório', textoAlerta: 'Por favor insira o <b>Número do Cartão</b>', iconAlerta: 'warning' }
        })
        return;
      }

      if (this.validade == '') {
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: 'Para continuar você deve inserir a <b>Validade do Cartão</b>', iconAlerta: 'warning' }
        })
        return;
      }
      else {
        console.log(this.validade.length);
        if (this.validade.length != 7) {
          const alertTipo = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { textoAlerta: 'A data de validade deve ser composta pelo mês/ano, exemplo: <b>01/2022</b>', iconAlerta: 'warning' }
          })
          return;
        }
      }

      if (this.cvv == '') {
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: 'Por favor insira o <b>Código de Segurança</b> do cartão', iconAlerta: 'warning' }
        })
        return;
      }


      if (this.numerocpf == '' || this.numerocpf.replace(/\./g, '').replace(/\-/g, '').length < 11) {
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: 'Por favor insira o <b>CPF</b> do titular do cartão', iconAlerta: 'warning' }
        })
        return;
      }

      if (this.numerocel == '') {
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: 'Por favor insira o <b>Celular</b> do titular do cartão', iconAlerta: 'warning' }
        })
        return;
      }

      if (this.nascimento == '') {
        const alertTipo = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: 'Por favor insira a <b>data de nascimento</b> do titular do cartão', iconAlerta: 'warning' }
        })
        return;
      }



      //confirmar que realiza o pedido nas condições

      var frasePed = "";

      var valorParcx = 0;

      if (this.qParcelas != 1) {
        valorParcx = this.arrParcelas.find(x => x.quantity == this.qParcelas).installmentAmount;
        frasePed = "Confirma a realização deste pedido e o pagamento em <b>" + this.qParcelas + " vezes</b>  de  <b>R$ " + valorParcx.toString().replace('.', ',') + "</b>?";
      }
      else {
        valorParcx = this.pagarVT;
        frasePed = "Confirma a realização deste pedido e o pagamento a vista no valor de <b>R$ " + valorParcx.toString().replace('.', ',') + "</b>?";
      }

   
      const dialogRecebeuCodigo = this.dialog.open(AlertaConfirmDialog, {
        // width: '250px',
        disableClose: true,
        data: { tituloAlerta: "Aviso",  textoAlerta: frasePed, textoCancel: "Não", textoConfirm: "Sim, realizar pagamento" }
      });
      dialogRecebeuCodigo.afterClosed().subscribe((result) => {
        console.log(result);
        if (result == true) {
          this.rotinaPgto();

        }
        else {

        }
      })

    }
    else {
      //0 já processamos
      //this.processarPagamento('');
    }

  }


  rotinaPgto(): void {
    //rotina ps
    var $this = this;
    this.hideCL = false;
    var minhaBandeira = "";
    var cardBinFormated = this.numerocc.replace(/\./g, '').toString().substring(0, 6);
    console.log("cad bin " + cardBinFormated);
    PagSeguroDirectPayment.getBrand({
      cardBin: cardBinFormated,
      success: function (response) {
        //bandeira encontrada
        minhaBandeira = response.brand.name;
        console.log("bandeira do cartao");
        console.log(minhaBandeira);
        $this.criarCardToken(minhaBandeira);
      },
      error: function (response) {
        //tratamento do erro
        console.log(response);
        $this.hideCL = true;
      },
      complete: function (response) {
        //tratamento comum para todas chamadas
        console.log(response);
      }
    });
  }

  criarCardToken(qBandeira: any): void {
    var $this = this;
    var mBandeira = qBandeira;
    var meuCardToken = "";
    var mCardNumber = this.numerocc.replace(/\./g, '');
    var mCardCVV = this.cvv;
    var mCardMonth = this.validade.substring(0, 2);
    var mCardYear = this.validade.substring(3, this.validade.length);
    console.log(mCardMonth, mCardYear, mCardNumber, mBandeira, mCardCVV);
    PagSeguroDirectPayment.createCardToken({
      cardNumber: mCardNumber, // Número do cartão de crédito
      brand: mBandeira, // Bandeira do cartão
      cvv: mCardCVV, // CVV do cartão
      expirationMonth: mCardMonth.replace("/", ""), // Mês da expiração do cartão
      expirationYear: mCardYear, // Ano da expiração do cartão, é necessário os 4 dígitos.
      success: function (response) {
        // Retorna o cartão tokenizado.
        console.log("token do cartao");
        console.log(response);
        console.log(response['card'].token);
        meuCardToken = response['card'].token;
        $this.processarPagamento(meuCardToken);
      },
      error: function (response) {
        // Callback para chamadas que falharam.
        console.log(response);
        //se der erro aqui, significa que algo no cartão tá inválido
        $this.hideCL = true;
        $this.alertarCartaoInvalido();
      },
      complete: function (response) {
        // Callback para todas chamadas.
      }
    });
  }

  alertarCartaoInvalido() {
    //this.meuInputCNumber.nativeElement.focus();
    setTimeout(() => {
      const alertTipo = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { tituloAlerta: "Erro dados do cartão!", textoAlerta: "Verifique as informações do cartão digitado e tente novamente", iconAlerta: 'warning' }
      })

      return;
    }, 0);

    // const erroCartao = this.dialog.open(AlertaSimplesDialog, {
    //   data: { tituloAlerta: "Erro dados do cartão!",  textoAlerta: "Verifique as informações do cartão digitado e tente novamente", iconAlerta: 'warning' }
    // })
    // return;

  }
  processarPagamento(meuCT: any): void {
    console.log("já temos a bandeira, agora aqui executa tudo");
    //chamada pagseguro
    var objCH = "";
    var objVal = "";
    var arrMCart = "";
    var objMEndereco = "";
    var formataNT = this.numerocel.replace('(', '').replace(')', '').replace('-', '');
    var fCelDDD = formataNT.substring(0, 2);
    var fCelNum = formataNT.substring(2, formataNT.length);

    var valorParc = 0;

    if (this.qParcelas != 1) {
      valorParc = this.arrParcelas.find(x => x.quantity == this.qParcelas).installmentAmount;
    }
    else {
      valorParc = this.pagarVT;
    }

    objVal = JSON.stringify({ 'senderhash': this.userSenderHash, 'cardtoken': meuCT });
    objCH = JSON.stringify({ 'nome': this.nomecc, 'cpf': this.numerocpf.replace(/\./g, '').replace('-', ''), 'nascimento': this.nascimento, 'celddd': fCelDDD, 'celnumber': fCelNum, 'logradouro': this.logradouro, 'numero': this.numero, 'complemento': this.complemento, 'bairro': this.bairro, 'cidade': this.cidade, 'uf': this.uf, 'cep': this.cep.replace("-", "") });
    arrMCart = JSON.stringify(this.tmaService.shopCartFull);
    objMEndereco = JSON.stringify(this.tmaService.shopEnderecoEntrega);

    let customParams = {
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      dadosCarrinho: arrMCart,
      dadosEndereco: objMEndereco,
      cupomdesconto: '',
      tipofrete: this.tmaService.shopTipoFrete,
      tipopagamento: 'online',
      dadosCartao: objCH,
      dadosValidar: objVal,
      qtyparcelas: this.qParcelas,
      valorparcelas: valorParc.toString().replace('.', ','),
      cpfcomprador: this.numerocpf.replace(/\./g, '').replace('-', ''),
      cidade: this.tmaService.shopCidade,
      uf: this.tmaService.shopUF
    };

    this.hideCL = false;
    //var dadosU = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idpaciente=' + this.idPaciente;
    this.tmaService.addNovoPedidoNM(customParams).subscribe((qRes) => {
      this.hideCL = true;
      console.log(qRes);
      this.ngZone.run(() => {
        if (qRes['res'] == 'done') {
          if (qRes['pagamento'] == true) {
            this.tmaService.shopCheck = false;
            this.checkoutDone = true;
            this.pgDone = true;
            this.tmaService.shopCartFull = [];
            localStorage.removeItem('tmsCarrinho');
            this.excluirIC();
          }
          else {
            //pagamento negado
            this.checkoutDone = true;
            this.pgDone = false;
          }
        }
        else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { textoAlerta: "Ocorreu um erro ao realizar o pedido. Tente novamente", iconAlerta: 'warning' }
          })
        }
      });
      
    },
      (error) => {
        this.hideCL = true;
        const erroCriar2 = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
        });
      })

  }

  tryNC(): void {
    this.checkoutDone = false;

  }





  excluirIC(): void {
    console.log("call ic");
    let customParams = {
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha
    };
    this.tmaService.zerarICart(customParams).subscribe();
  }

  goCheckout(): void {

  }
}
